export enum AutocompleteType {
  Text = 'text',
  Product = 'product',
  Facet = 'facetValue',
}

export type AutocompleteTypes = AutocompleteType.Text | AutocompleteType.Product | AutocompleteType.Facet;
